/* Red Diamond wish list: saved product handles live in the shopper's browser (localStorage). */
(() => {
  const KEY = 'rd-wishlist';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage blocked: list lasts for this page only */ }
  };
  let list = read();

  // Only touch the page when something actually changed: the MutationObserver below calls
  // paint() on every DOM change, so an unconditional write would re-trigger it forever.
  function paint() {
    document.querySelectorAll('[data-rd-wish]').forEach((btn) => {
      const on = String(list.includes(btn.dataset.rdWish));
      if (btn.getAttribute('aria-pressed') !== on) btn.setAttribute('aria-pressed', on);
      const label = btn.querySelector('[data-rd-wish-label]');
      const text = on === 'true' ? 'Favorited' : 'Favorite';
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-rd-wish-count]').forEach((el) => {
      const n = String(list.length);
      if (el.textContent !== n) el.textContent = n;
      if (el.hidden !== (list.length === 0)) el.hidden = list.length === 0;
    });
  }

  function toggle(handle) {
    list = list.includes(handle) ? list.filter((h) => h !== handle) : [...list, handle];
    write(list);
    paint();
    document.dispatchEvent(new CustomEvent('rd-wishlist:change', { detail: { list } }));
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rd-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.rdWish);
  });

  window.RDWishlist = { get: () => [...list], toggle, paint };
  document.addEventListener('DOMContentLoaded', paint);
  // Cards added later (filters, infinite scroll, quick add) get painted too.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
